module.exports = __webpack_public_path__ + "img/code.ac3be2bb.png";